import React, { createContext, useCallback, useContext, useState } from 'react';
import { openWhatsApp } from '../utils/whatsapp';
import { trackEmailCaptured, trackWhatsAppLead } from '../utils/analytics';
import { getStoredEmail, storeEmail } from '../utils/leadStore';
import { WhatsAppGateModal } from '../components/WhatsAppGateModal';
export interface WhatsAppRequest {
  message: string;
  location: string;
  intent?: string;
}
interface WhatsAppGateValue {
  /** Punto único de salida a WhatsApp: pide email (una vez), dispara Lead y abre el chat. */
  requestWhatsApp: (request: WhatsAppRequest) => void;
  rememberEmail: (email: string) => void;
}
const WhatsAppGateContext = createContext<WhatsAppGateValue | null>(null);
function withEmail(message: string, email: string): string {
  return /email:/i.test(message) ? message : `${message}\nEmail: ${email}`;
}
export function WhatsAppGateProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [pending, setPending] = useState<WhatsAppRequest | null>(null);
  const go = useCallback((request: WhatsAppRequest, email: string) => {
    trackWhatsAppLead(request.location, request.intent ?? 'cotizacion', email);
    openWhatsApp(withEmail(request.message, email));
  }, []);
  const requestWhatsApp = useCallback((request: WhatsAppRequest) => {
    const saved = getStoredEmail();
    if (saved) go(request, saved);else setPending(request);
  }, [go]);
  const rememberEmail = useCallback((email: string) => storeEmail(email), []);
  const handleConfirm = (email: string) => {
    if (!pending) return;
    storeEmail(email);
    trackEmailCaptured(email, pending.location);
    go(pending, email);
    setPending(null);
  };
  return <WhatsAppGateContext.Provider value={{
    requestWhatsApp,
    rememberEmail
  }} data-id="element-364" data-mp="1r8u9cdk7kzot">
      {children}
      <WhatsAppGateModal open={pending !== null} onClose={() => setPending(null)} onConfirm={handleConfirm} data-id="element-365" data-mp="3hlt4a4awcmgl" />
    </WhatsAppGateContext.Provider>;
}
export function useWhatsAppGate(): WhatsAppGateValue {
  const ctx = useContext(WhatsAppGateContext);
  if (!ctx) throw new Error('useWhatsAppGate debe usarse dentro de WhatsAppGateProvider');
  return ctx;
}